import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

export const DUPLICATE_APPOINTMENT_MENU_PRODUCT = graphql(`
  mutation DuplicateAppointmentMenuProduct($id: ID!) {
    duplicateAppointmentMenuProduct(id: $id) {
      id
      title
      code
      description
      enabled
      inStock
    }
  }
`);

export function useDuplicateAppointmentMenuProduct() {
  return useMutation(DUPLICATE_APPOINTMENT_MENU_PRODUCT, {
    refetchQueries: ['GetServiceDetail'],
  });
}
